import SolutionPageTemplate from "../components/SolutionPageTemplate";
import marketplace from "../Accets/marketplace.jpg";

export default function MarketplaceSolutions() {
  return (
    <SolutionPageTemplate
      title="Marketplace Solutions"
      subtitle="Power your marketplace with seamless payments, seller onboarding, automated settlements, and secure financial infrastructure for buyers and merchants."

      image={marketplace}

      challenges={[
        {
          title: "Complex Multi-Vendor Payments",
          description:
            "Managing payments between buyers, sellers, and platform commissions can become operationally challenging.",
        },
        {
          title: "Slow Seller Onboarding",
          description:
            "Manual KYC and verification processes delay merchant activation and business growth.",
        },
        {
          title: "Settlement Delays",
          description:
            "Delayed settlements impact seller satisfaction and reduce marketplace efficiency.",
        },
        {
          title: "Fraud Prevention",
          description:
            "Marketplaces require strong fraud detection and secure payment processing to protect buyers and sellers.",
        },
      ]}

      features={[
        {
          title: "Seller Onboarding",
          description:
            "Digitally onboard and verify merchants with fast, API-driven KYC processes.",
        },
        {
          title: "Escrow & Split Payments",
          description:
            "Automatically split payments between sellers, partners, and platform commissions.",
        },
        {
          title: "Automated Settlements",
          description:
            "Schedule and automate settlements to merchants without manual intervention.",
        },
        {
          title: "Payment Gateway",
          description:
            "Accept secure payments through UPI, cards, net banking, and digital wallets.",
        },
        {
          title: "Refund Management",
          description:
            "Handle cancellations and refunds with automated workflows for better customer experience.",
        },
        {
          title: "Analytics Dashboard",
          description:
            "Monitor transaction volumes, seller performance, settlements, and revenue in real time.",
        },
      ]}

      benefits={[
        {
          title: "Faster Merchant Growth",
          description:
            "Reduce onboarding time and enable sellers to start accepting payments quickly.",
        },
        {
          title: "Improved Customer Experience",
          description:
            "Provide secure, fast, and frictionless payment experiences for buyers.",
        },
        {
          title: "Automated Financial Operations",
          description:
            "Save time with automated settlements, reconciliation, and reporting.",
        },
        {
          title: "Enterprise-Grade Security",
          description:
            "Protect marketplace transactions with secure APIs and industry-standard compliance.",
        },
      ]}

      industries={[
        "B2B Marketplaces",
        "B2C Marketplaces",
        "Hyperlocal Commerce",
        "Food Delivery",
        "Travel Platforms",
        "E-Commerce Aggregators",
      ]}

      faqs={[
        {
          question: "Can I automate seller onboarding?",
          answer:
            "Yes. Our APIs enable digital KYC and merchant verification, reducing onboarding time significantly.",
        },
        {
          question: "Do you support split payments?",
          answer:
            "Yes. Payments can be automatically split between sellers, partners, and marketplace commissions.",
        },
        {
          question: "Can settlements be automated?",
          answer:
            "Absolutely. Configure settlement schedules and automate payouts to merchants securely.",
        },
        {
          question: "Is the platform secure?",
          answer:
            "Yes. Our infrastructure uses enterprise-grade security, encryption, and compliance standards to safeguard every transaction.",
        },
      ]}
    />
  );
}